import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../store/api/rx-factory'
import * as Enpoints from '../../../../store/api/endpoints'
import * as COMMON from '../../../../store/commomFunction'
import moment from 'moment'
export const actions = {
    //===================== CHART DATA ==================
    [Const.RUN_GET_USER_COPYTRADING_TOKEN]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_USER_COPYTRADING_TOKEN, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                if(result.res_data.hasOwnProperty('token') && result.res_data.token){
                    commit(Const.SET_USER_COPYTRADING_TOKEN, result.res_data);
                    credentials.localParams.parameter.fetchLeadersData()
                }else{
                    commit(Const.SET_USER_COPYTRADING_TOKEN, {});
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error');
            }
        })
    },
    [Const.RUN_GET_LEADERS_LIST]({ commit, state, getters, dispatch }, credentials) {
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
        COMMON._executeGetApi(Enpoints.EP_GET_LEADERS_LIST, credentials, { 'Authorization': 'Bearer ' + leadersdata.token}, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_LEADERS_LIST, result.res_data);
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error');
            }
        })
    },
    [Const.RUN_GET_LEADER_DETAIL]({ commit, state, getters, dispatch }, credentials) {
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
        COMMON._executeGetApi(Enpoints.EP_GET_LEADER_DETAIL, credentials, { 'Authorization': 'Bearer ' + leadersdata.token}, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_LEADER_DETAIL, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error');
            }
        })
    },
    [Const.RUN_FOLLOW_TRADE]({ commit, state, getters, dispatch }, credentials) {
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
        let apiType = credentials.localParams.isUpdate?'put':credentials.localParams.isDelete?'Delete':'post';
        let ep = credentials.localParams.isUpdate?Enpoints.EP_FOLLOW_TRADE_UPDATE:credentials.localParams.isDelete?Enpoints.EP_UNFOLLOW_TRADE:Enpoints.EP_FOLLOW_TRADE;
        if(credentials.localParams.postApi){
            ep = ep + credentials.localParams.postApi;
        }
        COMMON._executePostApi(ep, credentials, { 'Authorization': 'Bearer ' + leadersdata.token}, commit, apiType, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.getResponse(apiType)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_PROFIT_CHART_DATA]({commit, state,getters,dispatch}, credentials){
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
		let ep = Enpoints.EP_GET_LEADER_CHART_DATA;
		if(credentials.localParams.provider_id){
			ep = ep.concat("?provider_id="+credentials.localParams.provider_id+'&type='+credentials.localParams.type+'&timespan=DAILY&timeframe='+credentials.localParams.timeframe)
		}
		COMMON._executeGetApi(ep, credentials,{'Authorization': 'Bearer ' + leadersdata.token},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					commit(Const.SET_PROFIT_CHART_DATA, result.res_data)
					credentials.localParams.parameter.drawprofitChart()
				}else{
					commit(Const.SET_PROFIT_CHART_DATA, {})
				}
			}else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent.$parent,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_LEADER_TRADE_HISTORY_CHART_DATA]({commit, state,getters,dispatch}, credentials){
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
		let ep = Enpoints.EP_GET_LEADER_TRADE_HISTORY;
		if(credentials.localParams.provider_id){
			ep = ep.concat("?provider_id="+credentials.localParams.provider_id+'&type='+credentials.localParams.type+'&timespan=DAILY&brokerAccountId='+credentials.localParams.brokerAccountId+'&timeframe='+credentials.localParams.timeframe)
		}
		COMMON._executeGetApi(ep, credentials,{'Authorization': 'Bearer ' +  leadersdata.token},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					commit(Const.SET_LEADER_TRADE_HISTORY_CHART_DATA, result.res_data)
					setTimeout(function(){
						credentials.localParams.parameter.drawLeaderProfitChart()
					});
				}else{
					commit(Const.SET_LEADER_TRADE_HISTORY_CHART_DATA, {})
				}
			}else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent.$parent,result.res_data,'error')
			}
		})
  	},



	[Const.RUN_GET_PORTFOLIO_CHART_DATA]({commit, state,getters,dispatch}, credentials){
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
		let ep = Enpoints.EP_GET_LEADER_CHART_DATA;
		if(credentials.localParams.provider_id){
			ep = ep.concat("?provider_id="+credentials.localParams.provider_id+'&type='+credentials.localParams.type+'&timespan=STATS&timeframe='+credentials.localParams.timeframe)
		}
		COMMON._executeGetApi(ep, credentials,{'Authorization': 'Bearer ' +  leadersdata.token},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					commit(Const.SET_PORTFOLIO_CHART_DATA, result.res_data);
					setTimeout(()=>{
						credentials.localParams.parameter.drawTradingChartData();
					});
				}else{
					commit(Const.SET_PORTFOLIO_CHART_DATA, {})
				}
			}else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent.$parent,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_DRAWDOWN_CHART_DATA]({commit, state,getters,dispatch}, credentials){
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
		let ep = Enpoints.EP_GET_LEADER_CHART_DATA;
		if(credentials.localParams.provider_id){
			ep = ep.concat("?provider_id="+credentials.localParams.provider_id+'&type='+credentials.localParams.type+'&timespan=DAILY&timeframe='+credentials.localParams.timeframe)
		}
		COMMON._executeGetApi(ep, credentials,{'Authorization': 'Bearer ' + leadersdata.token},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					commit(Const.SET_DRAWDOWN_CHART_DATA, result.res_data);
					setTimeout(()=>{
						credentials.localParams.parameter.drawdownChart();
					});
				}else{
					commit(Const.SET_DRAWDOWN_CHART_DATA, {})
				}
			}else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent.$parent,result.res_data,'error')
			}
		})
  	},


	[Const.RUN_GET_PERFORMANCE_CHART_DATA]({commit, state,getters,dispatch}, credentials){
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
		let ep = Enpoints.EP_GET_LEADER_CHART_DATA;
		let timespan = '';
		if (credentials.localParams.type == "RANKING") {
			timespan = "";
		}
		else if (credentials.localParams.type == "BEST_TRADE,WORST_TRADE") {
			timespan = "DAILY";
		} else if (credentials.localParams.type == "CURRENCY_CLOSED_PROFIT_MONEY" || credentials.localParams.type == "CURRENCY_CLOSED_PROFIT") {
			timespan = "STATS";
		} else {
			timespan = "MONTHLY";
		}
		if(credentials.localParams.provider_id){
			ep = ep.concat("?provider_id="+credentials.localParams.provider_id+'&type='+credentials.localParams.type+'&timespan='+timespan+'&timeframe='+credentials.localParams.timeframe)
		}
		COMMON._executeGetApi(ep, credentials,{'Authorization': 'Bearer ' + leadersdata.token},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					commit(Const.SET_PERFORMANCE_CHART_DATA, result.res_data);
					setTimeout(()=>{
						credentials.localParams.parameter.drawPerformanceChartDecision()
					})
				}else{
					commit(Const.SET_PERFORMANCE_CHART_DATA, {})
				}
			}else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent.$parent,result.res_data,'error')
			}
		})
  	},
	[Const.RUN_GET_LEADER_TRADE_HISTORY]({commit, state,getters,dispatch}, credentials){
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
		let ep = Enpoints.EP_GET_LEADER_TRADE_HISTORY;
		if(credentials.localParams.provider_id){
			ep = ep.concat("?timeframe=10000&page="+credentials.localParams.page+'&size='+credentials.localParams.pageLimit+'&sort=dateClosed,desc&provider_id='+credentials.localParams.provider_id)
		}
		COMMON._executeGetApi(ep, credentials,{'Authorization': 'Bearer ' + leadersdata.token},commit, (error, result)=>{
			if(!error){
				if(Object.keys(result.res_data).length > 0){
					result.res_data['totalRecords'] = result.res_data.totalElements
					commit(Const.SET_LEADER_TRADE_HISTORY, result.res_data)
				}else{
					commit(Const.SET_LEADER_TRADE_HISTORY, {})
				}
			}else{
                COMMON._messageDisplayFunction(credentials.localParams.parameter.$parent.$parent,result.res_data,'error')
			}
		})
  	},
    [Const.RUN_GET_ALL_LEADERS_LIST]({ commit, state, getters, dispatch }, credentials) {
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
        COMMON._executePostApi(Enpoints.EP_GET_ALL_LEADERS_LIST, credentials, { 'Authorization': 'Bearer ' + leadersdata.token}, commit, 'post', (error, result) => {
            if (!error) {
                let newArray = result.res_data.result
                if(credentials.globalParams.page > 0){
                    if(credentials.globalParams.size > newArray.length){
                        credentials.localParams.parameter.loadmore = false;
                    }
                    newArray = credentials.localParams.parameter.allLeadersList.concat(newArray);
                }
                commit(Const.SET_ALL_LEADERS_LIST, newArray)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_FOLLOWERS_SETTING]({ commit, state, getters, dispatch }, credentials) {
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
        COMMON._executeGetApi(Enpoints.EP_GET_FOLLOWERS_SETTING, credentials, { 'Authorization': 'Bearer ' + leadersdata.token}, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_FOLLOWERS_SETTING, result.res_data)
                if(credentials.localParams.checkValue){
                    credentials.localParams.parameter.checkFollow()
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_USER_EQUITY_CHART_WITH_LEADER]({ commit, state, getters, dispatch }, credentials) {
        const leadersdata = getters[Const.GET_USER_COPYTRADING_TOKEN];
        let ep = Enpoints.EP_GET_USER_EQUITY_CHART_WITH_LEADER;
        if(credentials.localParams.provider_id){
			ep = ep.concat("?provider_id="+credentials.localParams.provider_id+'&type='+credentials.localParams.type+'&timespan=DAILY&brokerAccountId='+credentials.localParams.brokerAccountId+'&timeframe='+credentials.localParams.timeframe)
		}
        COMMON._executeGetApi(ep, credentials, { 'Authorization': 'Bearer ' + leadersdata.token}, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_USER_EQUITY_CHART_WITH_LEADER, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== CHART DATA ==================
    [Const.RUN_GET_TV_CHART_DATA]({ commit, state, getters, dispatch }, credentials) {
        return new Promise((resolve, reject) => {
            COMMON._executeApi(credentials.localParams.link, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
                if (!error) {
                    resolve(result.res_data);
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
                    reject(result.res_data);
                }
            })
        });
    },
    //===================== TECHNICAL ANALYSIS ==================
    [Const.RUN_GET_PIVOT_DATA]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PIVOT_DATA, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                if(result.res_data.length){
                    commit(Const.SET_PIVOT_DATA, result.res_data[0])
                }else{
                    commit(Const.SET_PIVOT_DATA, {})
                    
                }
            } else {
                commit(Const.SET_PIVOT_DATA, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== TECHNICAL ANALYSIS ==================
    [Const.RUN_GET_TECHNICAL_ANALYSIS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TECHNICAL_ANALYSIS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_TECHNICAL_ANALYSIS, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== GET RAW OBJECT ==================
    [Const.RUN_SET_RAW_OBJECT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_SET_RAW_OBJECT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_RAW_OBJECT, credentials.globalParams.setting)
                // commit(Const.SET_RAW_OBJECT, result.res_data)
                if(credentials.localParams.parameter.rawObjectSaved){
                    credentials.localParams.parameter.rawObjectSaved()
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_RAW_OBJECT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_RAW_OBJECT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                if(result.res_data[0] && result.res_data[0].setting){
                    COMMON._setDrawingToolLocalStorage(result.res_data[0].setting)
                    commit(Const.SET_RAW_OBJECT, result.res_data[0].setting)                  
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== PORTFOLIO Data ==================
    [Const.RUN_GET_PORTFOLIO]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PORTFOLIO, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                // console.log('SET_PORTFOLIO',result.res_data)
                let pointsArray = [], performanceArray = [], performanceJson = {}
                for(let i=0 ; i<=result.res_data.summary.points.length-1 ; i++){
                    let pointsJson = {
                        'date' :  new Date(result.res_data.summary.points[i][0]),
                        'balance' : result.res_data.summary.points[i][1],
                        'equity' : result.res_data.summary.points[i][1] + result.res_data.summary.points[i][2]
                    }
                    pointsArray.push(pointsJson)
                    if(i == result.res_data.summary.points.length-1){

                        result.res_data.summary['balanceEquityChart'] = pointsArray
                    }
                }

                for(let j=0 ; j<=result.res_data.profitability.length-1 ; j++){
                    for(let k=0 ; k<=result.res_data.profitability[j].points.length-1 ; k++){
                        if(!performanceJson.hasOwnProperty(result.res_data.profitability[j].points[k][0])){
                            performanceJson[result.res_data.profitability[j].points[k][0]] = {
                                'date' :  new Date(result.res_data.profitability[j].points[k][0]),
                                'equity' : result.res_data.profitability[j].points[k][1],
                                'balance' : result.res_data.profitability[j].points[k][2]
                            }
                        }else{
                            performanceJson[result.res_data.profitability[j].points[k][0]] = {
                                'date' :  new Date(result.res_data.profitability[j].points[k][0]),
                                'equity' : performanceJson[result.res_data.profitability[j].points[k][0]].equity + result.res_data.profitability[j].points[k][1],
                                'balance' : performanceJson[result.res_data.profitability[j].points[k][0]].balance + result.res_data.profitability[j].points[k][2]
                            }
                        }
                    }


                    if(j == result.res_data.profitability.length-1){
                        let sorted = _sortObjectByKeys(performanceJson)
                        Object.keys(sorted).forEach(function(keyEl) {
                            performanceArray.push(sorted[keyEl])
                        })
                        // console.log('performanceArray',performanceArray)
                        result.res_data.summary['performanceChart'] = performanceArray
                    }
                }


                commit(Const.SET_PORTFOLIO, result.res_data)
                credentials.localParams.parameter.calculateVolume()
                // console.log('-------------------------------------------------------><')
                credentials.localParams.parameter.performanceChart()
                credentials.localParams.parameter.equityBalanceChart()
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== USER SETTINGS ==================
    [Const.RUN_GET_CHART_DATA]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(credentials.localParams.link, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error && Array.isArray(result.res_data)) {
                if(credentials.localParams.type == 'day'){
                    credentials.localParams.parameter.oneDayData = result.res_data[0] || {}
                }
                if(credentials.localParams.type == 'year'){
                    let high=0,low=0;
                    if(result.res_data.length){
                        result.res_data.forEach(val=>{
                            if(high< val.high){ high = val.high; }
                            if(low == 0 || low > val.low){ low = val.low; }
                        })
                    }
                    credentials.localParams.parameter.prevYearData = {high,low}
                }
                // commit(Const.SET_ACTIVE_PRICE_ALERT, result.res_data.sort((a,b)=>  b.AlertID - a.AlertID) )
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== USER SETTINGS ==================
    [Const.RUN_GET_ACTIVE_PRICE_ALERT]({ commit, state, getters, dispatch }, credentials) {
        // console.log('---------------->',credentials.localParams.parameter.$options.name)
        COMMON._executeApi(Enpoints.EP_GET_ACTIVE_PRICE_ALERT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                // console.log('SET_ACTIVE_PRICE_ALERT',result.res_data)
                commit(Const.SET_ACTIVE_PRICE_ALERT, result.res_data.sort((a,b)=>  b.AlertID - a.AlertID) )
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== USER SETTINGS ==================
    [Const.RUN_GET_TRIGGERED_PRICE_ALERT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TRIGGERED_PRICE_ALERT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                // console.log('SET_TRIGGERED_PRICE_ALERT',result.res_data)
                commit(Const.SET_TRIGGERED_PRICE_ALERT, result.res_data.sort((a,b)=>  Date.parse(b.Triggered) - Date.parse(a.Triggered)) )
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== USER SETTINGS ==================
    [Const.RUN_SET_USER_SETTINGS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_SET_USER_SETTINGS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_USER_SETTINGS, credentials.globalParams)
                localStorage.setItem('SETTINGS', btoa(JSON.stringify(credentials.globalParams)))
                fontClass(credentials.globalParams)
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'USER SETTINGS Save successfully', 'success')
                try{
                    if(window['myStxx'] && window['myStxx'].tfc._isOpen){
                        window['myStxx'].tfc.updateData();
                    }
                }catch(e){ console.log(e)}
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_USER_SETTINGS]({ commit, state, getters, dispatch }, credentials) {
        if (localStorage.getItem('SETTINGS')) {
            commit(Const.SET_USER_SETTINGS, JSON.parse(atob(localStorage.getItem('SETTINGS'))))
            fontClass(JSON.parse(atob(localStorage.getItem('SETTINGS'))))
        }
        COMMON._executeApi(Enpoints.EP_GET_USER_SETTINGS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN}, commit, (error, result) => {
            if (!error) {
                if(result.res_data.length > 0){
                    let data = COMMON.flattenJSONStrings(result.res_data[0])
                    // console.log('--------------->', data)
                    commit(Const.SET_USER_SETTINGS, data)
                    if(credentials.localParams.call_from){
                        credentials.localParams.parameter.setStateData()
                    }
                    fontClass(data)
                    localStorage.setItem('SETTINGS', btoa(JSON.stringify(data)))
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== Create Demo Accont ==================
    [Const.RUN_CREATE_DEMO_ACC]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CREATE_DEMO_ACC, credentials, { 'Authorization': 'Bearer'}, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.login(result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== USER ACCOUNTS ==================
    [Const.RUN_GET_USER_ACCOUNTS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_USER_ACCOUNTS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                result.res_data.accountInfo.Currency = result.res_data.accountInfo.Currency.replace(/_/g, "");
                commit(Const.SET_USER_ACCOUNTS, result.res_data.accountInfo)
                if(result.res_data.profile){
                    commit(Const.SET_USER_PROFILE, result.res_data.profile)
                }
            } else {
                /*if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
                    credentials.localParams.parameter.$parent.authComponent = true
                }*/
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== SERVER TYPE LIST ==================
    [Const.RUN_GET_PROVIDER_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PROVIDER_LIST, credentials, { 'Authorization': 'Bearer'}, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_PROVIDER_LIST, result.res_data.list)
            } else {
                /*if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
                    credentials.localParams.parameter.$parent.authComponent = true
                }*/
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //====================== ACCOUNT REPORTS ==================
    [Const.RUN_GET_ACCOUNT_REPORTS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_ACCOUNT_REPORTS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                // console.log(result.res_data)
                credentials.localParams.parameter.openHeader = false
                window.open(result.res_data.reportLink, '_blank');
            } else {
                /*if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
                    credentials.localParams.parameter.$parent.authComponent = true
                }*/
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //===================== 2FA API ==================
    [Const.RUN_GENERATE_2FA_QRCODE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GENERATE_2FA_QRCODE, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                console.log(result.res_data)
                credentials.localParams.parameter.QrCodeImage = result.res_data.qrCode
                credentials.localParams.parameter.secureKey = result.res_data.secureKey
            } else {
                /*if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
                    credentials.localParams.parameter.$parent.authComponent = true
                }*/
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_VERIFY_2FA_QRCODE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_VERIFY_2FA_QRCODE, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                // console.log('success',result.res_data)

                let user_json = getters[types.GET_USER]
                user_json.profile.u2fa_flag = 1
                commit(types.SET_STATE, user_json)

                var user = localStorage.getItem('user')
                user = atob(user);
                user = JSON.parse(user)
                user.profile.u2fa_flag = 1
                localStorage.setItem('user', btoa(JSON.stringify(user)))

                credentials.localParams.parameter.div_show = ''
                credentials.localParams.parameter.otp = ''
                COMMON._messageDisplayFunction(credentials.localParams.parameter, '2FA Enabled successfully', 'success')
            } else {
                // console.log('error',result.res_data)
                credentials.localParams.parameter.otpError = result.res_data
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')

            }
        })
    },
    [Const.RUN_DISABLE_2FA_QRCODE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_DISABLE_2FA_QRCODE, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.DisableOtp = ''
                credentials.localParams.parameter.div_show = ''
                credentials.localParams.parameter.generateQrCode()

                let user_json = getters[types.GET_USER]
                user_json.profile.u2fa_flag = 0
                commit(types.SET_STATE, user_json)
                var user = localStorage.getItem('user')
                user = atob(user);
                user = JSON.parse(user)
                user.profile.u2fa_flag = 0
                localStorage.setItem('user', btoa(JSON.stringify(user)))

                COMMON._messageDisplayFunction(credentials.localParams.parameter, '2FA Disabled successfully', 'success')
            } else {
                credentials.localParams.parameter.otpError = result.res_data
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    // ================= WATCH LIST ================================
    [Const.RUN_GET_WATCH_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_WATCH_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_WATCH_LIST, result.res_data)
                // if(credentials.localParams.parameter.subList)
                let idFound = false
                result.res_data.forEach((val,index)=>{
                    if(val._id === credentials.localParams.parameter.watchId){
                        idFound = true
                        credentials.localParams.parameter.fevList = (val.is_fav)?val.is_fav:[]
                        credentials.localParams.parameter.setWatch(val)
                    }
                    if(index == result.res_data.length-1 && !idFound){
                        credentials.localParams.parameter.setWatch(result.res_data[0])
                    }
                })
            } else {
                commit(Const.SET_WATCH_LIST, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_CREATE_WATCH_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_CREATE_WATCH_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.createWatchSuccess = true
                credentials.localParams.parameter.watchId = result.res_data.watchlistId
                credentials.localParams.parameter.watchLiting()
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_UPDATE_WATCH_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_UPDATE_WATCH_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.editWatchSuccess = true
                credentials.localParams.parameter.watchLiting()
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_DELETE_WATCH_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_DELETE_WATCH_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.delWatchSuccess = true
                credentials.localParams.parameter.watchLiting()
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    // ================= CURRENCY PAIRS ================================
    [Const.RUN_GET_CURRENCY_PAIRS]({ commit, state, getters, dispatch }, credentials) {
        if(localStorage.getItem('ISINS_LIST')){
            commit(Const.SET_CURRENCY_PAIRS, JSON.parse(localStorage.getItem('ISINS_LIST')))
        }
        COMMON._executeApi(Enpoints.EP_GET_CURRENCY_PAIRS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if(result.res_data.length > 0){
                    commit(Const.SET_CURRENCY_PAIRS, result.res_data)
                    localStorage.setItem('ISINS_LIST',JSON.stringify(result.res_data));
                }
            } else {
                commit(Const.SET_CURRENCY_PAIRS, [])
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_PRICE_SHIFT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PRICE_SHIFT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_PRICE_SHIFT, result.res_data);
                // credentials.localParams.parameter.startChart();
            } else {
                commit(Const.SET_PRICE_SHIFT, {})
                // credentials.localParams.parameter.startChart();
                // COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error');
            }
        })
    },
    // ================= ACCOUNT BALANCE ================================
    [Const.RUN_GET_ACCOUNT_BALANCE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_ACCOUNT_BALANCE, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                result.res_data.ACCOUNT_CURRENCY = result.res_data.ACCOUNT_CURRENCY.replace(/_/g, "");
                commit(Const.SET_ACCOUNT_BALANCE, result.res_data);
                localStorage.setItem('Account-Currency',result.res_data.ACCOUNT_CURRENCY)
            } else {
                commit(Const.SET_ACCOUNT_BALANCE, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    // ================= TRANSACTION HISTORY ================================
    [Const.RUN_GET_TRANSACTION_HISTORY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TRANSACTION_HISTORY, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_TRANSACTION_HISTORY, result.res_data.sort((a,b)=>  Date.parse(formatDate(b.TRANSACTION_DATE)) - Date.parse(formatDate(a.TRANSACTION_DATE)) ))
            } else {
                commit(Const.SET_TRANSACTION_HISTORY, [])
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    // ================= open Trade =======================================
    [Const.RUN_GET_OPEN_TRADE]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_OPEN_TRADE, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let resultdata = result.res_data.sort((a,b)=>  Date.parse(b.OpenTime) - Date.parse(a.OpenTime) ).map(v=>{
                    let date = moment(v.OpenTime).add(4, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSSSSS');
                    v.date = date
                    return v
                })
                commit(Const.SET_OPEN_TRADE, resultdata)
            } else {
                commit(Const.SET_OPEN_TRADE, [])
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    // ================= pending order =====================================
    [Const.RUN_GET_PENDING_ORDER]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PENDING_ORDER, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let resultdata = result.res_data.sort((a,b)=>  Date.parse(b.OpenTime) - Date.parse(a.OpenTime) ).map(v=>{
                    let date = moment(v.OpenTime).add(4, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSSSSS');
                    v.date = date
                    return v
                })
                commit(Const.SET_PENDING_ORDER, resultdata);
                credentials.localParams.parameter.setWatchList();
            } else {
                commit(Const.SET_PENDING_ORDER, [])
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    // ================= Trade History ================================
    [Const.RUN_GET_TRADE_HISTORY]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_TRADE_HISTORY, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let resultdata = result.res_data.sort((a,b)=>  Date.parse(b.CloseTime) - Date.parse(a.CloseTime) )
                commit(Const.SET_TRADE_HISTORY, resultdata)
                commit(Const.SET_CALL_TRADE_HISTORY_API, false)
            } else {
                commit(Const.SET_TRADE_HISTORY, [])
                if(!credentials.localParams.hasOwnProperty('from')){
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
                }
            }
        })
    },
    [Const.RUN_GET_REMOVED_TRADE_LIST]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_REMOVED_TRADE_LIST, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let rejected = result.res_data.filter(val=>val.RemovedBy == 'system').sort((a,b)=>  Date.parse(b.RemoveTime) - Date.parse(a.RemoveTime) )
                let pending = result.res_data.filter(val=>val.RemovedBy != 'system').sort((a,b)=>  Date.parse(b.RemoveTime) - Date.parse(a.RemoveTime) )

                commit(Const.SET_REJECTED_TRADE, rejected)
                commit(Const.SET_PENDING_TRADE, pending)
            } else {
                // commit(Const.SET_PENDING_ORDER, [])
                if(!credentials.localParams.hasOwnProperty('from')){
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
                }
            }
        })
    },
    // ================== ECONOMIC CALENDER ================================
    [Const.RUN_GET_ECONOMIC_CALENDER_DATA]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_ECONOMIC_CALENDER_DATA, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let auto_chartist = {}
                if(result.res_data.length > 0){
                    for(let i=0 ; i<=result.res_data.length-1 ; i++){
                        const eventDate = moment(result.res_data[i].Date).format("YYYY-MM-DD")
                        if(auto_chartist[eventDate]){
                            auto_chartist[eventDate].push(result.res_data[i])
                        }else{
                            auto_chartist[eventDate] = []
                            auto_chartist[eventDate].push(result.res_data[i])
                        }
                        if(i == result.res_data.length-1){
                            commit(Const.SET_ECONOMIC_CALENDER_DATA, auto_chartist)
                        }
                    }
                }
            } else {
                commit(Const.SET_ECONOMIC_CALENDER_DATA, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    // ================== news data ================================
    [Const.RUN_GET_NEWS_DATA]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_NEWS_DATA, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_NEWS_DATA, result.res_data)
            } else {
                commit(Const.SET_NEWS_DATA, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    // =============================================================================
    [Const.RUN_TRADING_ACCOUNT]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_TRADING_ACCOUNT, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (result.res_data.length > 0) {
                    commit(Const.SET_TRADING_ACCOUNT, result.res_data)
                    try {
                        credentials.localParams.parameter.currency = result.res_data[0].subAccounts[0]
                    } catch (error) {}
                } else {
                    commit(Const.SET_TRADING_ACCOUNT, [])
                }
            } else {
                commit(Const.SET_TRADING_ACCOUNT, [])
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_PAYMENT_METHODS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PAYMENT_METHODS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_PAYMENT_METHODS, result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_PROFILE_INFO]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_PROFILE_INFO, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_PROFILE_INFO, result.res_data[0])
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },


}
function fontClass(val){
    if(val.font_size == 'small'){
        document.body.classList.remove("largeFont")
        document.body.classList.add("smallFont")
    }else if(val.font_size == 'medium'){
        document.body.classList.remove("largeFont")
        document.body.classList.remove("smallFont")
    }else if(val.font_size == 'large'){
        document.body.classList.remove("smallFont")
        document.body.classList.add("largeFont")
    }
}
function formatDate(val){
    let date = '';
    try{
        date += val.slice(0, 4) //YYYY
        date += "-"+val.slice(4, 6) //MM
        date += "-"+val.slice(6, 8) //DD
        date += "T"+val.slice(8, 10) //HH
        date +=":"+val.slice(10, 12) //mm
        date +=":"+val.slice(12, 14) //ss
    }catch(e){}
    return date
}
function _sortObjectByKeys(o) {
    return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
}
/*
function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') { getToken = '' }
        credentials.localParams.parameter.pageLoader = true

        RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                    credentials.localParams.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            response_array.res_data = data.data
                            callback(false, response_array)
                        } else {
                            if (typeof data.msg == 'object') {
                                response_array.res_data = data.msg.msg
                            } else {
                                response_array.res_data = data.msg
                            }
                            callback(true, response_array)
                        }
                    }
                },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

function _messageDisplayFunction(getParameter, getMessage, msgType) {
    //getParameter.response_msg = getMessage
    //getParameter.msg_type = msgType
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
}

function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) {}
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}

function _handleLogout(data, commit, options) {
    const router = options.router
    let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}*/


// WEBPACK FOOTER //
// ./src/plugins/commonAll/provider/store-addons/actions.js